


















































import { defineComponent, PropType } from '@vue/composition-api'
import { searchCarCategories } from '~/api/RentalCar'
import Autocomplete from '~/components/Autocomplete.vue'
import DateTimePicker from '~/components/DateTimePicker.vue'
import TextButton from '~/components/TextButton.vue'
import { VueForm } from '~/utils/interfaces'
import {
  CarSearch,
  CarSearchCategory,
  CreateCarBooking,
} from '~/utils/interfaces/rentalCar'
import vRules from '~/utils/vRules'

export default defineComponent({
  components: { DateTimePicker, Autocomplete, TextButton },
  props: {
    crud: {
      type: Object as PropType<CreateCarBooking>,
      required: true,
    },
    active: Boolean,
  },
  data() {
    return {
      vRules,
      data: {
        categories: [],
        total_days: 0,
        pick_up_office: '',
        pick_up_office_name: '',
        drop_off_office: '',
        drop_off_office_name: '',
        pick_up_datetime: '',
        drop_off_datetime: '',
      } as CarSearch,
      loading: false,
    }
  },
  methods: {
    onNext() {
      return (this.$refs.form as VueForm).validate()
    },
    onSelect(i: CarSearchCategory) {
      this.crud.category = i.category
    },
  },
  watch: {
    async active(v: boolean) {
      if (v) {
        try {
          this.loading = true
          const response = await searchCarCategories({
            pick_up_office: this.crud.pick_office,
            pick_up_datetime: this.crud.start_datetime,
            drop_off_office: this.crud.drop_office,
            drop_off_datetime: this.crud.end_datetime,
            category: this.crud.category,
          })
          this.data = response.data
        } finally {
          this.loading = false
        }
      }
    },
  },
})
